import React from "react";
import { Link } from "react-router-dom";
import { Phone, MessageCircle, Mail } from "lucide-react";
import { useCms } from "../lib/cms";

export default function SiteFooter() {
  const { cms } = useCms();
  const phone = (cms?.legal?.impressum?.phone) || "+49 176 56198464";
  const phoneDigits = phone.replace(/\D/g, "") || "4917656198464";
  const email = (cms?.legal?.impressum?.email) || "";

  return (
    <footer className="mt-24 border-t border-slate-200 bg-white" data-testid="site-footer">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-10">
        <div>
          <div className="flex items-center gap-2.5 mb-3">
            <img
              src="/leukas-logo.png"
              alt="Leukas Umzug Service Logo"
              width="640"
              height="641"
              className="h-16 w-auto object-contain rounded-lg"
              data-testid="footer-logo"
            />
            <div className="leading-tight">
              <div className="font-heading font-bold text-slate-900 text-base">Leukas Umzug Service</div>
              <div className="text-[11px] uppercase tracking-widest text-slate-500">Aachen, Köln, Düsseldorf & Umgebung</div>
            </div>
          </div>
          <p className="text-sm text-slate-600 max-w-sm leading-relaxed">
            Faire Preise, sorgfältiger Transport, schnelle Termine. Ihr verlässlicher Partner für
            Umzüge, Möbeltransporte und Entrümpelung – feste Teams in Aachen, Köln, Düsseldorf und Umgebung.
          </p>
        </div>

        <div>
          <h4 className="font-heading font-semibold text-slate-900 mb-3 text-sm uppercase tracking-widest">Schnellzugriff</h4>
          <ul className="space-y-2 text-sm text-slate-600">
            <li><Link to="/angebot?type=full" className="hover:text-brand-navy" data-testid="footer-quote-link">Angebot erhalten</Link></li>
            <li><Link to="/entruempelung" className="hover:text-brand-navy" data-testid="footer-clearance-link">Entrümpelung</Link></li>
            <li><Link to="/impressum" className="hover:text-brand-navy" data-testid="footer-impressum-link">Impressum</Link></li>
            <li><Link to="/datenschutz" className="hover:text-brand-navy" data-testid="footer-datenschutz-link">Datenschutz</Link></li>
            <li>
              <a href={`tel:${phoneDigits ? "+" + phoneDigits : ""}`} className="inline-flex items-center gap-1 hover:text-brand-navy" data-testid="footer-contact-link">
                <Phone size={13} /> Kontakt
              </a>
            </li>
            <li>
              <a href={`https://wa.me/${phoneDigits}`} target="_blank" rel="noreferrer" className="inline-flex items-center gap-1 hover:text-brand-navy" data-testid="footer-whatsapp-link">
                <MessageCircle size={13} /> WhatsApp
              </a>
            </li>
            <li>
              <a href="/admin/login" target="_blank" rel="noreferrer" className="inline-flex items-center gap-1 text-slate-400 hover:text-slate-700" data-testid="footer-admin-link">
                Admin Kalender ↗
              </a>
            </li>
          </ul>
        </div>

        <div>
          <h4 className="font-heading font-semibold text-slate-900 mb-3 text-sm uppercase tracking-widest">Kontakt</h4>
          <ul className="space-y-2 text-sm text-slate-600">
            <li className="inline-flex items-center gap-1.5">
              <MessageCircle size={13} className="text-green-600" />
              WhatsApp:&nbsp;
              <a href={`https://wa.me/${phoneDigits}`} target="_blank" rel="noreferrer" className="text-brand-amberDark font-semibold hover:underline">{phone}</a>
            </li>
            <li className="inline-flex items-center gap-1.5">
              <Phone size={13} />
              Telefon:&nbsp;
              <a href={`tel:${phoneDigits ? "+" + phoneDigits : ""}`} className="hover:text-brand-navy">{phone}</a>
            </li>
            {email && (
              <li className="inline-flex items-center gap-1.5">
                <Mail size={13} />
                <a href={`mailto:${email}`} className="hover:text-brand-navy">{email}</a>
              </li>
            )}
            <li>Aachen · Köln · Düsseldorf · Umgebung</li>
          </ul>
        </div>
      </div>

      <div className="border-t border-slate-100">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-5 text-xs text-slate-500 flex flex-col sm:flex-row gap-2 justify-between">
          <span>© {new Date().getFullYear()} Leukas Umzug Service · Alle Rechte vorbehalten.</span>
          <span className="flex gap-3">
            <Link to="/impressum" className="hover:text-slate-700">Impressum</Link>
            <Link to="/datenschutz" className="hover:text-slate-700">Datenschutz</Link>
          </span>
        </div>
      </div>
    </footer>
  );
}
